module.exports = __webpack_public_path__ + "static/media/instagram.45337101.svg";